
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Weddingdestinationnearwardha() {



  const cardData =
  {
    keyword: ' Wedding Destination Near Wardha',
    heading:  'Woodland Escape: Wedding Destination Near Wardha ',
    headingDescription: 'Woodland Escape Resort is a stunning destination wedding resort near Wardha, set amidst lush greenery, spacious lawns and tranquil open grounds where every ceremony—from engagement to sangeet to the main wedding—can be beautifully hosted under nature’s canopy. With ample guest accommodations, flexible indoor-outdoor venue options, and a dedicated event team managing décor, catering and guest comfort, the resort guarantees a seamless and elegant celebration. Couples and families will love the blend of rustic-chic charm, comfortable cottages and scenic photo-worthy spots that create lifelong memories. Whether you’re planning an intimate gathering or a grand affair, Woodland Escape Resort near Wardha offers the perfect backdrop for a destination wedding that combines peace, luxury and natural beauty.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Wedding Destination Near Wardha",
      "description": "Discover the perfect wedding destinations near Wardha offering exquisite venues surrounded by lush greenery, scenic landscapes, and tranquil settings. Ideal for couples seeking a memorable celebration, these locations provide versatile spaces for ceremonies, receptions, and pre-wedding functions, along with professional staff to assist in planning every detail for a seamless and magical wedding experience."
    },
    {
      "name": "Wardha Wedding Venue",
      "description": "Choose from a variety of wedding venues in Wardha that cater to different preferences and guest sizes. From elegant halls to open-air gardens, these venues are equipped with modern facilities, decorative options, and experienced event managers to ensure your big day is executed flawlessly, making every moment unforgettable for you and your guests."
    },
    {
      "name": "Wardha Luxury Wedding Location",
      "description": "Experience luxury weddings in Wardha at resorts offering premium amenities, lavish décor, fine dining options, and personalized services. These top-tier locations provide breathtaking backdrops, professional wedding planners, and exclusive accommodations for the couple and their families, ensuring a sophisticated and memorable celebration in a serene environment."
    },
    {
      "name": "Affordable Wedding Spot Wardha",
      "description": "Plan your dream wedding in Wardha without exceeding your budget at affordable wedding spots offering quality facilities, picturesque surroundings, and customizable packages. These venues balance elegance and value, providing essential amenities such as catering, décor, and guest accommodations while maintaining a charming and memorable setting for your special day."
    },
    {
      "name": "Wardha Pre Wedding Shoot Location",
      "description": "Capture your love story at Wardha’s top pre-wedding shoot locations featuring scenic gardens, riversides, and hilltops. Perfect for romantic and creative photoshoots, these spots provide natural light, unique backdrops, and privacy, making your pre-wedding photography session a delightful and stress-free experience with breathtaking results."
    },
    {
      "name": "Wardha Outdoor Wedding Spot",
      "description": "Celebrate your wedding amidst nature at Wardha’s outdoor wedding spots offering open lawns, charming gazebos, and panoramic views. These locations allow flexible arrangements for decorations, seating, and entertainment, creating an enchanting ambiance for both daytime and evening ceremonies surrounded by fresh air and natural beauty."
    },
    {
      "name": "Wardha Riverside Wedding Venue",
      "description": "Host a serene riverside wedding in Wardha with scenic water views, tranquil surroundings, and spaces for both ceremonies and receptions. These venues offer a romantic and picturesque setting with opportunities for outdoor décor, photography, and water-themed celebrations, making your wedding truly memorable for you and your guests."
    },
    {
      "name": "Wardha Hill Wedding Location",
      "description": "Celebrate your wedding on a hilltop in Wardha with panoramic vistas, cool breezes, and natural beauty all around. Hill wedding locations offer privacy, breathtaking backdrops, and a peaceful ambiance, perfect for intimate ceremonies, sunset photography, and creating a magical experience for the couple and their guests."
    },
    {
      "name": "Wardha Family Wedding Resort",
      "description": "Plan a family-friendly wedding at Wardha resorts that combine luxury accommodations, spacious banquet halls, and recreational facilities. These resorts cater to both ceremony and leisure needs, providing entertainment options, kid-friendly areas, and comfortable lodging to ensure that guests of all ages enjoy a memorable and stress-free celebration."
    },
    {
      "name": "Wardha Resort Wedding Packages",
      "description": "Explore curated wedding packages at Wardha resorts that include accommodation, catering, décor, and event coordination. These packages are designed to simplify wedding planning, offering customizable options for ceremonies, receptions, pre-wedding events, and group activities while ensuring high-quality service and a seamless celebration experience."
    },
    {
      "name": "Wardha Wedding Booking Online",
      "description": "Easily book your wedding venue in Wardha online to secure preferred dates, accommodations, and facilities. Online booking platforms provide detailed information, images, and package options, allowing you to plan your wedding efficiently, compare venues, and finalize arrangements from the comfort of your home with confidence and convenience."
    },
    {
      "name": "Wardha Wedding Hall",
      "description": "Host your wedding at a spacious and elegantly designed hall in Wardha, featuring modern facilities, customizable seating arrangements, and professional event support. These halls are ideal for large gatherings, cultural ceremonies, and indoor receptions, providing a comfortable and sophisticated setting for a memorable celebration."
    },
    {
      "name": "Wardha Marriage Destination",
      "description": "Choose Wardha as your marriage destination to combine scenic beauty, cultural charm, and well-equipped venues. With a variety of resorts, outdoor locations, and customized services, couples can plan a destination wedding that reflects their style, accommodates their guests comfortably, and creates lifelong memories in a stunning environment."
    },
    {
      "name": "Wardha Resort for Wedding",
      "description": "Celebrate your wedding at top resorts in Wardha offering picturesque surroundings, luxurious accommodations, and comprehensive event services. These resorts provide flexibility for ceremonies, receptions, and leisure activities, ensuring a comfortable and enjoyable experience for both the couple and their guests."
    },
    {
      "name": "Wardha Wedding Destination Packages",
      "description": "Choose from comprehensive wedding destination packages in Wardha that include venue arrangements, catering, décor, photography, and accommodation. These packages are designed to simplify planning, providing all-inclusive solutions for couples seeking a stress-free and beautifully organized wedding celebration in a serene and scenic location."
    }
  ],
  "tableData": [
    ["- Wedding Destination Near Wardha", "- Wardha Wedding Venue"],
    ["- Wardha Luxury Wedding Location", "- Affordable Wedding Spot Wardha"],
    ["- Wardha Pre Wedding Shoot Location", "- Wardha Outdoor Wedding Spot"],
    ["- Wardha Riverside Wedding Venue", "- Wardha Hill Wedding Location"],
    ["- Wardha Family Wedding Resort", "- Wardha Resort Wedding Packages"],
    ["- Wardha Wedding Booking Online", "- Wardha Wedding Hall"],
    ["- Wardha Marriage Destination", "- Wardha Resort for Wedding"],
    ["- Wardha Wedding Destination Packages", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Perfect Destination Wedding Resort Near Wardha",
    "WhyChoosedescription": "Woodland Escape Resort offers an enchanting venue for destination weddings near Wardha. With its lush green landscapes, serene surroundings and open-air charm, it provides a beautiful and memorable setting for your dream celebration."
  },
  {
    "WhyChooseheading": "Scenic Outdoor Wedding Venues",
    "WhyChoosedescription": "Exchange vows amidst Nature—spacious lawns surrounded by trees and gentle open skies. The resort’s natural beauty adds a graceful touch to every moment, making your wedding photos and ceremony truly special."
  },
  {
    "WhyChooseheading": "Spacious Banquet & Lawn Areas",
    "WhyChoosedescription": "Woodland Escape Resort features expansive lawns and event-friendly zones that can be tailored for your ceremony, reception and pre-wedding functions. Whether you envision an intimate gathering or a grand affair, the space adapts to your needs."
  },
  {
    "WhyChooseheading": "Comfortable Accommodation for Guests",
    "WhyChoosedescription": "Your guests can relax and enjoy the celebration without worrying about accommodation. The resort provides comfortable lodging, so your wedding party, family and friends can stay onsite, ensuring ease, flow and togetherness throughout the festivities."
  },
  {
    "WhyChooseheading": "Personalised Wedding Planning Support",
    "WhyChoosedescription": "From décor and catering to logistics and guest coordination, the resort team assists in planning every detail of your event. This ensures your special day unfolds smoothly and is customised exactly to your vision."
  },
  {
    "WhyChooseheading": "Delicious Multi-Cuisine Wedding Catering",
    "WhyChoosedescription": "Treat your guests to a delightful culinary experience with freshly prepared local and multi-cuisine menus. The resort’s catering options are designed to complement the wedding grandeur, satisfying diverse tastes and dietary preferences."
  },
  {
    "WhyChooseheading": "Tranquil & Romantic Natural Ambience",
    "WhyChoosedescription": "Surrounded by nature’s calm, the resort’s peaceful setting enhances the romantic feel of a destination wedding. The greenery, open skies, gentle breeze and natural light all work together to create an unforgettable atmosphere for you and your loved ones."
  },
  {
    "WhyChooseheading": "Easily Accessible from Wardha",
    "WhyChoosedescription": "Located within a convenient drive from Wardha, Woodland Escape Resort offers the right balance of accessibility and seclusion. Guests can reach the venue without hassle, yet it retains the feel of a retreat away from the everyday."
  }
]





















  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a wedding destination near Wardha?",
    answer: "Woodland Escape Resort is an ideal wedding destination near Wardha, offering sprawling green lawns, serene surroundings, and picturesque backdrops perfect for wedding ceremonies and celebrations."
  },
  {
    question: "How far is Woodland Escape Resort from Wardha city?",
    answer: "The resort is conveniently located within driving distance from Wardha, making it easy for guests to reach while providing a tranquil and beautiful setting for a memorable wedding."
  },
  {
    question: "What facilities does Woodland Escape Resort provide for weddings?",
    answer: "The resort offers spacious lawns for ceremonies, elegant décor options, accommodation for guests, catering services, and dedicated areas for pre-wedding and wedding events."
  },
  {
    question: "Is Woodland Escape Resort suitable for family and friends attending a wedding?",
    answer: "Yes! The resort is family-friendly and group-friendly, ensuring safe, comfortable, and spacious arrangements for all wedding guests."
  },
  {
    question: "Does Woodland Escape Resort offer catering and event management for weddings?",
    answer: "Absolutely. The resort provides customized catering options, refreshments, and event management support to make your wedding a seamless and unforgettable experience."
  },
  {
    question: "How can we book Woodland Escape Resort as a wedding destination near Wardha?",
    answer: "You can book by calling or WhatsApp messaging our reservations team, or by visiting the official website. Advance booking is highly recommended for wedding dates."
  }
];

const testimonials = [
  {
    name: "Mr. & Mrs. Deshmukh, Wardha",
    text: "We had our wedding at Woodland Escape Resort, and it was magical! The natural surroundings, beautiful lawns, and friendly staff made our wedding unforgettable. Highly recommended near Wardha."
  },
  {
    name: "Ms. Shreya & Mr. Sameer, Wardha",
    text: "Woodland Escape Resort is perfect for a wedding! The space, greenery, and arrangements exceeded our expectations. Our guests loved it, and we couldn’t have asked for a better wedding venue near Wardha."
  }
];



























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Destination Near Wardha",
  "image": "https://woodlandescape.com/assets/images/wardha-wedding-resort.jpg",
  "description": "Host your dream wedding at Woodlandescape Resort near Wardha. Perfect for luxury weddings, riverside ceremonies, hilltop celebrations, pre-wedding shoots, and family-friendly events.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "58"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/wedding-destination-wardha"
  }
};




  return (
    <div>
<Helmet>
  <title>Wedding Destination Near Wardha | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan a luxurious wedding near Wardha at Woodlandescape Resort. Ideal for outdoor weddings, riverside venues, hilltop ceremonies, pre-wedding shoots, and family celebrations." 
  />
  <meta 
    name="keywords" 
    content="Wedding Destination Near Wardha, Wardha Wedding Venue, Wardha Luxury Wedding Location, Affordable Wedding Spot Wardha, Wardha Pre Wedding Shoot Location, Wardha Outdoor Wedding Spot, Wardha Riverside Wedding Venue, Wardha Hill Wedding Location, Wardha Family Wedding Resort, Wardha Resort Wedding Packages, Wardha Wedding Booking Online, Wardha Wedding Hall, Wardha Marriage Destination, Wardha Resort for Wedding, Wardha Wedding Destination Packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/39.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Weddingdestinationnearwardha;